import { memo, type FC } from 'react';

import { Pin as PinIcon } from '@/core/tamagoshi/icons/Pin';
import { Text } from '@/core/tamagoshi/Text/Text';
import { productCountItems } from '@/domains/proB2BServices/Wishlists/translations';

import styles from './CardText.module.scss';

interface Props {
  isBasket?: boolean;
  productCount: number;
  name: string;
}

const CardTextComponent: FC<Props> = ({ productCount = 0, isBasket, name }) => (
  <div className={styles.itemTextContainer}>
    <Text
      type="body2"
      tag="span"
      weight="semiBold"
      className={styles.titleTextField}
    >
      {name}
    </Text>
    <div className={styles.itemCountTextField}>
      {isBasket ? (
        <PinIcon className={styles.itemBasketIcon} height="18px" width="18px" />
      ) : null}
      <Text
        type="body2"
        tag="span"
        weight="semiBold"
        className={productCount === 0 ? styles.itemEmptyListText : undefined}
        variant="none"
      >
        {productCountItems?.format({ productCount })}
      </Text>
    </div>
  </div>
);

export const CardText = memo(CardTextComponent);
